import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=d0c93148&"
import script from "./Alert.vue?vue&type=script&lang=ts&"
export * from "./Alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c93148')) {
      api.createRecord('d0c93148', component.options)
    } else {
      api.reload('d0c93148', component.options)
    }
    module.hot.accept("./Alert.vue?vue&type=template&id=d0c93148&", function () {
      api.rerender('d0c93148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alert.vue"
export default component.exports